// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DbmgrOperator
 */
export interface DbmgrOperator {
  /**
   *
   * @type {string}
   * @memberof DbmgrOperator
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof DbmgrOperator
   */
  status?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof DbmgrOperator
   */
  supportedNeo4jVersions?: Array<string>;
}

/**
 * Check if a given object implements the DbmgrOperator interface.
 */
export function instanceOfDbmgrOperator(value: object): value is DbmgrOperator {
  return true;
}

export function DbmgrOperatorFromJSON(json: any): DbmgrOperator {
  return DbmgrOperatorFromJSONTyped(json, false);
}

export function DbmgrOperatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DbmgrOperator {
  if (json == null) {
    return json;
  }
  return {
    name: json['Name'] == null ? undefined : json['Name'],
    status: json['Status'] == null ? undefined : json['Status'],
    supportedNeo4jVersions:
      json['SupportedNeo4jVersions'] == null
        ? undefined
        : json['SupportedNeo4jVersions'],
  };
}

export function DbmgrOperatorToJSON(json: any): DbmgrOperator {
  return DbmgrOperatorToJSONTyped(json, false);
}

export function DbmgrOperatorToJSONTyped(
  value?: DbmgrOperator | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Name: value['name'],
    Status: value['status'],
    SupportedNeo4jVersions: value['supportedNeo4jVersions'],
  };
}
